import { render, staticRenderFns } from "./CaseificioSync.vue?vue&type=template&id=24c55002"
import script from "./CaseificioSync.vue?vue&type=script&lang=js"
export * from "./CaseificioSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports